/**
* @file 系统设置-轮播广告-新增/编辑广告
* */
<template>
  <div id="stickerForm">
    <el-dialog title="如何获取appid" :visible.sync="visibleAppid" width="900px" :close-on-click-modal="false" append-to-body>
      <div class="appid">
        <div>
          <div>第一步</div>
          <img src="@/assets/img/appid1.png" />
        </div>
        <div>
          <div>第二步</div>
          <img src="@/assets/img/appid2.png" />
        </div>
        <div>
          <div>第三步</div>
          <img src="@/assets/img/appid2.png" />
        </div>
      </div>
    </el-dialog>


    <h2 style="margin-bottom:30px;">{{ `${id ? '编辑' : '新增'}广告` }}</h2>

    <p class="stickerFormDes">贴纸广告会展示在乘客端首页底部</p>

    <div class="stickerFormResult">
      <div>
        <p class="stickerFormResultTitle">{{ form.title ? form.title : '标题' }}</p>
        <p class="stickerFormResultdes">{{ form.content ? form.content : '内容展示区域' }}</p>
      </div>
      <img v-if="form.iconImg || form.iconImgUp"
        :src="form.iconImgUp ? mixinQiniuImg(form.iconImgUp) : mixinQiniuImg(form.iconImg)" alt="">
    </div>
    <el-form :model="form" :rules="rules" ref="form" label-width="90px">
      <el-form-item label="标题" prop="title">
        <el-input v-model="form.title" placeholder="请输入标题" maxlength="8" style="width:200px"></el-input>
      </el-form-item>
      <el-form-item label="内容" prop="content">
        <el-input v-model="form.content" placeholder="请输入内容" maxlength="20" style="width:200px"></el-input>
      </el-form-item>
      <el-form-item label="插画" prop="iconImg" class="custom-form-img">
        <div class="sticker-example-img">
          <img :src="mixinQiniuImg('stickerone.png')" @click="imgClick('stickerone.png')" alt="">
          <img :src="mixinQiniuImg('stickertwo.png')" @click="imgClick('stickertwo.png')" alt="">
          <img :src="mixinQiniuImg('stickerthree.png')" @click="imgClick('stickerthree.png')" alt="">
          <img :src="mixinQiniuImg('stickerfour.png')" @click="imgClick('stickerfour.png')" alt="">
          <img :src="mixinQiniuImg('stickerfive.png')" @click="imgClick('stickerfive.png')" alt="">
          <img :src="mixinQiniuImg('stickersix.png')" @click="imgClick('stickersix.png')" alt="">
          <up-img @remove="$set(form, 'iconImg', '')" :file.sync="form.iconImgUp" width="156" height="156"></up-img>
        </div>
        <p class="stickerFormDes">贴纸广告会展示在乘客端首页底部</p>

      </el-form-item>
      <el-form-item label="跳转页面" prop="jumpType">
        <JumpTypeSelector
          :jumpType="form.jumpType"
          :jumpTo="form.jumpTo"
          @update:jumpType="jumpChange($event, 'jumpType')"
          @update:jumpTo="jumpChange($event, 'jumpTo')"
          @show-appid-info="visibleAppid = true"
        ></JumpTypeSelector>

      </el-form-item>
      <el-form-item label="是否启用"> <!--状态1-启用，2-禁用-->
        <el-switch v-model="form.status" :active-value="1" :inactive-value="2"></el-switch>
      </el-form-item>
      <el-form-item style="margin-top: 50px;">
        <el-button type="primary" @click="saveClick" :loading="loading">保存</el-button>
        <!-- <el-button @click="backClick">返回</el-button> -->
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import JumpTypeSelector from '../components/JumpTypeSelector.vue';
export default {
  name: "stickerForm",
  components: {
    JumpTypeSelector
  },
  data() {
    let validateValidityType = (rule, value, callback) => {
      if (value || this.form.iconImgUp) {
        callback()
      } else {
        callback(new Error('请选择插画'))
      }
    };
    return {
      // 贴纸id（从路由获取）
      stickerId: this.$route.query.id,
      // 表单
      form: {
        jumpType: null,
        jumpTo: null
      },
      // 校验规则
      rules: {
        title: [{ required: true, message: '请输入标题内容' }],
        content: [{ required: true, message: '请输入内容' }],
        iconImg: [{ required: true, validator: validateValidityType }],
        jumpType: [{ required: true, message: '请选择跳转页面' }]
      },
      // 保存按钮loading
      loading: false,
      visibleAppid: false,
    }
  },
  props: {
    id: Number,
    visible: Boolean
  },
  watch: {
    id: {
      handler(val) {
        val && this.getInfo()
      },
      immediate: true
    },
    visible(val) {
      if (!val) {
        this.form = { jumpTo: null }
      }
    }
  },
  created() {
    this.getInfo()
  },
  methods: {
    jumpChange(val, name) {
      this.$set(this.form, name, val)
    },

    imgClick(name) {
      this.$set(this.form, 'iconImgUp', '')
      this.$set(this.form, 'iconImg', name)
    },

    saveClick() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.form.jumpType == 1 && !this.form.jumpTo) {
            this.$message.info('请填写appid');
            return;
          } else if (this.form.jumpType == 2 && !this.form.jumpTo) {
            this.$message.info('请填写网页链接');
            return;
          }  else if (this.form.jumpType == 5 && !this.form.jumpTo) {
            this.$message.info('请选择线路');
            return;
          }else if (this.form.jumpType == 3) {
            this.form.jumpTo = '旅游包车页面';
          }
          let params = this.$utils.deepCopyFn(this.form);
          if (params.iconImgUp) {
            params.iconImg = params.iconImgUp
            delete params.iconImgUp
          }
          if (this.id) {
            this.putFn(params)
          } else {
            this.postFn(params)
          }
        } else {
          this.$message.warning('请检查表单数据是否输入正确！');
          return false;
        }
      });
    },

    async postFn(params) {
      this.loading = true;
      let url = '/api/v1/manage/banner/sticker';
      let data = await this.$axios.post(url, params);
      if (data && data.code === 1) {
        this.$message.success('保存成功！');
        this.$emit('advertisingClose')
      }
      this.loading = false
    },

    async putFn(params) {
      this.loading = true;
      let url = '/api/v1/manage/banner/sticker';
      let data = await this.$axios.put(url, params);
      if (data && data.code === 1) {
        this.$message.success('保存成功！');
        this.$emit('advertisingClose')
      }
      this.loading = false
    },

    async getInfo() {
      if (!this.id) {
        return false
      }
      let url = '/api/v1/manage/banner/sticker/' + this.id;
      let data = await this.$axios.get(url)
      if (data && data.code === 1) {
        if (data.data.iconImg.indexOf('.png') < 0) {
          data.data.iconImgUp = data.data.iconImg
        }
        this.form = data.data || {}
      }
    },

    backClick() {
      this.$emit('advertisingClose')
    }
  },
}
</script>

<style lang="less">
#stickerForm {
  .el-form-item__label {
    text-align: left;
  }

  .custom-form-img {
    .el-form-item__label {
      line-height: 156px;
    }

    .stickerFormDes {
      padding-top: 16px;
    }
  }

  .stickerFormTitle {
    font-size: 20px;
    font-weight: 600;
    line-height: 27px;
    color: #333333;
    opacity: 1;
  }

  .stickerFormDes {
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    padding-top: 4px;
    color: #999999;
    opacity: 1;
  }

  .stickerFormResult {
    width: 686px;
    height: 188px;
    background: #FFFFFF;
    border: 1px dashed #ebebeb;
    border-radius: 4px;
    display: flex;
    align-items: center;
    margin: 24px 0;
    justify-content: space-between;

    .stickerFormResultTitle {
      font-size: 36px;
      font-weight: 600;
      color: #333333;
      line-height: 48px;
      display: flex;
      align-items: center;
      margin-left: -1px;

      &:before {
        content: '';
        display: block;
        width: 6px;
        height: 36px;
        margin-right: 27px;
        background: #FF9E3D;
      }
    }

    img {
      width: 156px;
      height: 156px;
      border-radius: 16px;
      margin-right: 24px;
    }

    .stickerFormResultdes {
      padding-top: 14px;
      padding-left: 32px;
      font-size: 24px;
      font-weight: 400;
      line-height: 30px;
      color: #666666;
      opacity: 1;
    }
  }

  .sticker-example-img {
    display: flex;
    flex-wrap: wrap;

    .up-img {
      height: 156px;

      .up-img-content .content-img {
        border-radius: 16px;
        border-style: dashed;
      }

      .content-img-up {
        border-radius: 16px;
      }
    }

    img {
      width: 156px;
      /*margin-bottom: 34px;*/
      height: 156px;
      box-sizing: border-box;
      border: 1px dashed #ebebeb;
      border-radius: 16px;
      margin-right: 20px;
      cursor: pointer;
    }
  }


  .radio-row {
    margin-bottom: 10px;
    display: flex;
    align-items: center;

    .el-radio {
      flex-shrink: 0;
      width: 120px
    }
  }

  .radio-tips {
    margin: 0 0 20px 150px;
    font-size: 10px;

    span {
      color: #66b1ff;
      cursor: pointer;
    }
  }

  .appid {
    padding: 20px 10px;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-column-gap: 50px;

    div {
      color: #333;
      font-weight: bold;
    }

    img {
      width: 100%;
      margin-top: 10px;
      border: 5px #f7f7f7 solid;
    }
  }
}
</style>
